import { bootstrapService } from '@/api'
import customServiceTemplate from '@/store/modules/provider/custom_service'
import { APP_MODE_SPACE, APP_MODE_SITE } from '@/common/constants'

const initialState = () => ({
  mode: null,
  isTouchDevice: false,
  isVisible: true
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    isModeSpace: state => state.mode === APP_MODE_SPACE,
    isModeSite: state => state.mode === APP_MODE_SITE
  },
  mutations: {
    isTouchDevice(state, isTouchDevice) {
      state.isTouchDevice = isTouchDevice
    },
    isVisible(state, isVisible) {
      state.isVisible = isVisible
    },
    toggleIsVisible(state) {
      state.isVisible = !state.isVisible
    },
    mode(state, mode) {
      state.mode = mode
    }
  },
  actions: {
    async bootstrap({ commit, dispatch }, siteId) {
      try {
        const { account, site, provider, project } = await bootstrapService.get(
          siteId
        )
        console.log(project)
        commit('account/assign', account, { root: true })
        commit('site/assign', site, { root: true })
        commit('provider/assign', provider, { root: true })
        commit('provider/fields/assign', provider.fields, { root: true })
        commit('provider/labels/assign', provider.labels, { root: true })
        if (project) {
          commit('provider/projects/active/assign', project, { root: true })
        }
        return provider.custom_services
      } catch (e) {
        // die gracefully
        console.warn('Picnic Bootup Failed:', e.message)
        return null
      }
    }
  }
}
